import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import Navigation from '../../constants/enums/NavigationEnum'
import ExternalLinks from '../../constants/enums/ExternalLinksEnum'
import menuIcon from '../../images/menuIcon.svg'
import Logo from '../../images/dynamicIcons/logo'
import CloseIcon from '../../images/dynamicIcons/closeIcon'
import ExitIcon from '../../images/dynamicIcons/exitIcon'
import Vk from '../../images/dynamicIcons/social_vk'
import Yt from '../../images/dynamicIcons/social_yt'
import Ok from '../../images/dynamicIcons/social_ok'
import Tg from '../../images/dynamicIcons/social_tg'
import appstoreIcon from '../../images/appstoreIcon.svg'

const tabs = [
    { name: "Главная", href: Navigation.GeneralPage, available: true },
    { name: "Услуги", href: Navigation.ServiceList, available: false },
    { name: "Заявки", href: Navigation.AppealListPage, available: true },
    //{ name: "Финансы", href: Navigation.FinancePage, available: true },
    { name: "Чат", href: Navigation.Chat, available: false }
]

type NavMenuProps = RouteComponentProps

interface NavMenuState {
    menuIsOpen: boolean
}

class NavMenu extends React.PureComponent<NavMenuProps, NavMenuState> {

    constructor(props: NavMenuProps) {
        super(props);
        this.state = {
            menuIsOpen: false
        }

        this.IsCurrentpPath = this.IsCurrentpPath.bind(this);
    }

    IsCurrentpPath(expectedPath: string) {
        let path = this.props.location.pathname?.toLowerCase();
        return path === expectedPath || path.startsWith(expectedPath.toLowerCase())
    }

    public render() {

        return (
            <>
                <div className={`side-menu_wrapper ${this.state.menuIsOpen && "isOpen"}`} >
                    <div className='side-menu-background' onClick={
                        () => {
                            document.getElementById("root")?.classList.remove("no-relative");
                            this.setState({ menuIsOpen: false });
                        }}></div>
                    <div className="side-menu">
                        <div className='side-menu_header'>
                            <div className='side-menu_header_wrapper'>
                                <div className='side-menu_header_wrapper_img'><Logo /></div>
                                <div className='side-menu_header_wrapper_img'
                                    onClick={() => {
                                        document.getElementById("root")?.classList.remove("no-relative");
                                        this.setState({ menuIsOpen: false });
                                    }}
                                ><CloseIcon /></div>

                            </div>
                            <div className='side-menu_header_devider'></div>
                        </div>
                        <div className='side-menu_nav'>
                            <a target='_blank' href={ExternalLinks.CyfralServiceSite} className='side-nav--500'>Перейти на сайт Цифрал-Сервис</a>
                            <a target='_blank' href={ExternalLinks.CyfralServiceSite} className='side-nav--500 mp'>Перейти в приложение «Умный Дом.ru»</a>
                            <a className='side-nav--400' style={{ display: "flex", gap: "4px", alignItems: "center" }}
                                onClick={() => this.props.history.push(Navigation.AuthLogout)}>Выйти <ExitIcon /></a>
                        </div>
                        <div className='flex-separator'></div>
                        <div className='side-menu_additional'>
                            <div className='side-menu_additional_links'>
                                <a target='_blank' href={ExternalLinks.CyfralServiceSite_forOrganization} className='side-nav--400'>Для УК и ТСЖ</a>
                                <a target='_blank' href={ExternalLinks.CyfralServiceSite_offices} className='side-nav--400'>Офисы </a>
                            </div>
                            <div className='side-menu_additional_social'>
                                <a target='_blank' href={ExternalLinks.Social_vk} ><Vk /></a>
                                <a target='_blank' href={ExternalLinks.Social_ok} ><Ok /></a>
                                <a target='_blank' href={ExternalLinks.Social_yt} ><Yt /></a>
                                <a target='_blank' href={ExternalLinks.Social_tg} ><Tg /></a>

                            </div>
                        </div>
                    </div>
                </div>
                <header>
                    <div className='nav nav-text'>
                        <a href={Navigation.GeneralPage}><Logo /></a>
                        <div className='nav__devider'></div>
                        <div className='nav__items'
                            style={{
                                display: this.props.location.pathname.toLocaleLowerCase() === Navigation.SubscriptionPage.toLocaleLowerCase()
                                    ? "none" : ""
                            }}>
                            {tabs.map((element, index) => {
                                return <div key={index} className={`nav__items_item 
                                ${this.IsCurrentpPath(element.href) && 'selected'}
                                ${!element.available && "disabled"}`}
                                    onClick={() => {
                                        if (element.available)
                                            this.props.history.push(element.href)
                                    }}
                                >{element.name}</div>
                            })}
                        </div>
                        <div className='nav__devider_grow'></div>
                        <div className='nav__buttons'>
                            <a target='_blank' href='https://erth.page.link/o5ma' className='nav-mp-text button nav__buttons_mp'>
                                <img src={appstoreIcon} />
                                <div className=''>Умный Дом.ru</div>
                            </a>
                            <img onClick={() => {
                                document.getElementById("root")?.classList.add("no-relative");
                                this.setState({ menuIsOpen: true });
                            }}
                                src={menuIcon} className='button'></img>
                        </div>

                    </div>

                </header>
            </>
        );
    }
}

export default connect(
    null,
    null
)(withRouter(NavMenu) as any);


